import React from "react";
import loaderWebp100 from "../../../image/loader/loader_100.webp";
import loaderWebp1000 from "../../../image/loader/loader_1000.webp";
import loaderWebp1250 from "../../../image/loader/loader_1250.webp";
import loaderWebp150 from "../../../image/loader/loader_150.webp";
import loaderWebp1500 from "../../../image/loader/loader_1500.webp";
import loaderWebp1750 from "../../../image/loader/loader_1750.webp";
import loaderWebp2160 from "../../../image/loader/loader_2160.webp";
import loaderWebp250 from "../../../image/loader/loader_250.webp";
import loaderWebp50 from "../../../image/loader/loader_50.webp";
import loaderWebp500 from "../../../image/loader/loader_500.webp";
import loaderWebp750 from "../../../image/loader/loader_750.webp";

/** Loader image width in pixels. */
const LOADER_WIDTH = 150;

/**
 * Responsive search-loading image shown while OD itinerary search is in flight.
 *
 * @returns Centered loader image with multi-resolution `srcSet`.
 */
const ItinerarySearchLoader: React.FC = () => {
    return (
        <div
            className="flex justify-center content-center items-center pt-20 pb-20 w-full"
            id="itinerary-list-search-loader"
        >
            <img
                alt="Chargement..."
                loading="eager"
                sizes={`${ LOADER_WIDTH }px`}
                src={loaderWebp150}
                srcSet={`
                    ${ loaderWebp50 } 30w,
                    ${ loaderWebp100 } 60w,
                    ${ loaderWebp150 } 100w,
                    ${ loaderWebp250 } 150w,
                    ${ loaderWebp500 } 300w,
                    ${ loaderWebp750 } 450w,
                    ${ loaderWebp1000 } 600w,
                    ${ loaderWebp1250 } 750w,
                    ${ loaderWebp1500 } 900w,
                    ${ loaderWebp1750 } 1000w,
                    ${ loaderWebp2160 } 1300w
                `}
                style={{
                    "height": "auto",
                    "width":  `${ LOADER_WIDTH }px`,
                }}
            />
        </div>
    );
};

export default ItinerarySearchLoader;
